<template>
  <!-- pc登录 -->
  <div class="register-wrap">
    <!-- <RemoteScript src="./jquery.min.js"></RemoteScript> -->
    <div class="register-bg"></div>
    <div class="register-content">
      <p class="register-title">注册</p>
      <div class="register-btn">
        <a class="register-btn-a" href="//web.etiantian.com/ett20/study/usermanage/studentregister.jsp" target="_blank">
        <!-- <a class="register-btn-a" href="https://gw1.bj.etiantian.com:15280/ett20/study/usermanage/studentregister.jsp" target="_blank"> -->
          <img src="../../assets/images/login/zc_photo.png" alt="">
          <p>学生</p>
        </a>
      </div>
      <div class="other-btn">
        <span>已有账号？</span>
        <span class="to-login" @click="goLogin">马上登录</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    goLogin() {
      let url = this.$router.resolve({
        path: '/login'
      })
      window.open(url.href, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.register-wrap {
  width: 100%;
  height: 100vh;
  background: #fff;
  display: flex;
  min-width: 1200px;
  min-height: 750px;
  font: 14px/1.5 "Microsoft Yahei", tahoma, Srial, helvetica, sans-serif;
  .register-bg {
    width: 50%;
    min-width: 600px;
    height: 100%;
    flex-shrink: 0;
    background: url('../../assets/images/login/zc_bg.png') no-repeat;
    background-position: center;
    background-size: cover;
  }
  .register-content {
    width: 50%;
    min-width: 600px;
    height: 100%;
    padding-top: 170px;
    text-align: center;
    .register-title {
      display: inline-block;
      font-size:48px;
      font-weight:bold;
      color:rgba(33,124,254,1);
      line-height: 32px;
      border-bottom: 14px solid rgba(255,129,86,1);
    }
    .register-btn {
      margin-top: 80px;
      font-size: 18px;
      color: rgba(79,79,79,1);
      text-align: center;
      &-a {
        display: inline-block;
        img {
          border-radius: 50%;
          border: 8px solid transparent;
        }
        p {
          line-height: 50px;
        }
      }
      &-a:hover {
        color: #FF8156;
        img {
          border: 8px solid #FF8156;
        }
      }
    }
    .other-btn {
      font-size: 14px;
      color: rgba(79,79,79,1);
      line-height: 32px;
      margin-top: 70px;
      font-weight: 500;
      .to-login {
        color: #217CFE;
        cursor: pointer;
      }
    }
  }
}
</style>